import axios from 'axios';
import { AUTH } from 'endpointsConst';
import { setCookie } from 'utils/cookies';

export async function refreshAuthTokens(refreshToken: string): Promise<void> {
  const res = await axios.post<{
    accessToken: string;
    refreshToken: string;
    accessTokenExpiresIn: number;
    refreshTokenExpiresIn: number;
  }>(AUTH.REFRESH, { refreshToken });

  setCookie('access_token', res.data.accessToken, res.data.accessTokenExpiresIn);
  setCookie('refresh_token', res.data.refreshToken, res.data.refreshTokenExpiresIn);
}
